import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M19.081 19.857H4.91803C3.31503 19.857 2.00903 18.552 2.00903 16.947V5.92997C2.00903 5.87097 2.01603 5.81397 2.03003 5.75997C1.98903 5.52097 2.01303 5.27297 2.10703 5.03897C2.33203 4.47797 2.88903 4.14197 3.59803 4.14197H20.627C21.026 4.14197 21.349 4.46597 21.349 4.86397C21.349 5.26197 21.025 5.58697 20.627 5.58697H3.59703C3.57603 5.58697 3.55703 5.58697 3.54003 5.58897L10.945 12.999C11.222 13.276 11.588 13.429 11.979 13.429C12.37 13.429 12.736 13.277 13.013 12.999L18.675 7.33297C19.308 6.69897 20.156 6.49397 20.884 6.79497C21.565 7.07697 21.988 7.75997 21.988 8.57797V16.948C21.988 18.552 20.683 19.857 19.079 19.857H19.081ZM3.45503 7.54497V16.948C3.45503 17.757 4.11103 18.414 4.91803 18.414H19.081C19.889 18.414 20.546 17.757 20.546 16.948V8.57797C20.546 8.44297 20.518 8.20597 20.333 8.13097C20.198 8.07497 19.951 8.10097 19.699 8.35497L14.036 14.021C13.488 14.571 12.757 14.874 11.98 14.874C11.203 14.874 10.474 14.57 9.92403 14.02L3.45403 7.54497H3.45503Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'Envelope');

export default Icon;
